import { defineMessages } from '@dragonraider5/react-intl'

export default defineMessages({
  model200: {
    id: 'containers.Applications.Steps.Documents.labels.model200',
    description: 'Label message for model200 uploader',
    defaultMessage:
      `Modelo 200: Impuesto de sociedades. Año {period}. {required, select,
        true { * }
        other {}
      }`
  },
  model100: {
    id: 'containers.Applications.Steps.Documents.labels.model100',
    description: 'Label message for model100 uploader',
    defaultMessage:
      `Modelo 100: Declaración de la renta. Año {period}. {required, select,
        true { * }
        other {}
      }`
  },
  model390: {
    id: 'containers.Applications.Steps.Documents.labels.model390',
    description: 'Label message for model390 uploader',
    defaultMessage:
      `Modelo 390: IVA. Declaración Resumen Anual. Año {period}. {required, select,
        true { * }
        other {}
      }`
  },
  model303: {
    id: 'containers.Applications.Steps.Documents.labels.model303',
    description: 'Label message for model303 uploader',
    defaultMessage:
      `Modelo 303: IVA. Autoliquidación.
       Año {year} {period_tax, select,
        mensual {Mes}
        trimestral {Trimestre}
      } {period}. {required, select,
        true { * }
        other {}
      }`
  },
  model425: {
    id: 'containers.Applications.Steps.Documents.labels.model425',
    description: 'Label message for model425 uploader',
    defaultMessage:
      `Modelo 425. Declaración resumen anual. Año {period}. {required, select,
        true { * }
        other {}
      }`
  },
  model420: {
    id: 'containers.Applications.Steps.Documents.labels.model420',
    description: 'Label message for model420 uploader',
    defaultMessage:
      `Modelo 420. IGIC. Autoliquidación trimestral
       Año {year} {period_tax, select,
        mensual {Mes}
        trimestral {Trimestre}
       } {period}. {required, select,
        true { * }
        other {}
      }`
  },
  model410: {
    id: 'containers.Applications.Steps.Documents.labels.model410',
    description: 'Label message for model410 uploader',
    defaultMessage:
      `Modelo 410. IGIC. Autoliquidación mensual.
       Año {year} {period_tax, select,
        mensual {Mes}
        trimestral {Trimestre}
       } {period}. {required, select,
        true { * }
        other {}
      }`
  },
  model130: {
    id: 'containers.Applications.Steps.Documents.labels.model130',
    description: 'Label message for model130 uploader',
    defaultMessage:
      `Modelos 130: IRPF. Estimación Directa.
       Año {year} Trimestre {period}. {required, select,
        true { * }
        other {}
      }`
  },
  balance_closed: {
    id: 'containers.Applications.Steps.Documents.labels.balance_closed',
    description: 'Label message for balance_closed uploader',
    defaultMessage:
      `Cierre del último año completo de balance y cuenta de resultados. {required, select,
        true { * }
        other {}
      }`
  },
  auditory: {
    id: 'containers.Applications.Steps.Documents.labels.auditory',
    description: 'Label message for auditory uploader',
    defaultMessage:
      `Auditoría último año. {required, select,
        true { * }
        other {}
      }`
  },
  balance: {
    id: 'containers.Applications.Steps.Documents.labels.balance',
    description: 'Label message for balance uploader',
    defaultMessage:
      `Balance y cuenta de resultados del año en curso. {required, select,
        true { * }
        other {}
      }`
  },
  budget: {
    id: 'containers.Applications.Steps.Documents.labels.budget',
    description: 'Label message for budget uploader',
    defaultMessage:
      `Presupuesto del año siguiente. {required, select,
        true { * }
        other {}
      }`
  },
  prevision: {
    id: 'containers.Applications.Steps.Documents.labels.prevision',
    description: 'Label message for prevision uploader',
    defaultMessage:
      `Previsión del año que viene. {required, select,
        true { * }
        other {}
      }`
  },
  certificateHacienda: {
    id: 'containers.Applications.Steps.Documents.labels.certificateHacienda',
    description: 'Label message for certificateHacienda uploader',
    defaultMessage:
      `Certificado de Hacienda. {required, select,
        true { * }
        other {}
      }`
  },
  certificateSegSocial: {
    id: 'containers.Applications.Steps.Documents.labels.certificateSegSocial',
    description: 'Label message for certificateSegSocial uploader',
    defaultMessage:
      `Certificado de la Seguridad Social. {required, select,
        true { * }
        other {}
      }`
  },
  model347: {
    id: 'containers.Applications.Steps.Documents.labels.model347',
    description: 'Label message for model347 uploader',
    defaultMessage:
      `Modelo 347: Declaración de operaciones con terceros. Año {period}. {required, select,
        true { * }
        other {}
      }`
  },
  rating: {
    id: 'containers.Applications.Steps.Documents.labels.rating',
    description: 'Label message for rating uploader',
    defaultMessage:
      `Informe de tasación. {required, select,
        true { * }
        other {}
      }`
  },
  invoice: {
    id: 'containers.Applications.Steps.Documents.labels.invoice',
    description: 'Label message for invoice uploader',
    defaultMessage:
      `Factura/s proforma de la inversión a realizar. {required, select,
        true { * }
        other {}
      }`
  },
  contract: {
    id: 'containers.Applications.Steps.Documents.labels.contract',
    description: 'Label message for contract uploader',
    defaultMessage:
      `Contrato/resolución subvención/convenio. {required, select,
        true { * }
        other {}
      }`
  },
  discount: {
    id: 'containers.Applications.Steps.Documents.labels.discount',
    description: 'Label message for discount uploader',
    defaultMessage:
      `Contrato/resolución subvención/convenio {required, select,
        true { * }
        other {}
      }`
  },
  treasury: {
    id: 'containers.Applications.Steps.Documents.labels.treasury',
    description: 'Label message for treasury uploader',
    defaultMessage:
      `Cuadro de tesorería. {required, select,
        true { * }
        other {}
      }`
  },
  endorsement: {
    id: 'containers.Applications.Steps.Documents.labels.endorsement',
    description: 'Label message for endorsement uploader',
    defaultMessage:
      `Modelo aval. {required, select,
        true { * }
        other {}
      }`
  },
  other: {
    id: 'containers.Applications.Steps.Documents.labels.other',
    description: 'Label message for other uploader',
    defaultMessage:
      `Otra información.`
  },
})
